import type { ComponentType } from '@grafikr/components';

import initMegaMenu from './parts/mega-menu';
import initMobileMenu from './parts/mobile-menu';
import initSearch from './parts/search';

const Component: ComponentType = (node, { app }) => {
  const CLASSES = {
    HEADER_OVERLAY_ACTIVE: 'header--has-overlay',
  };

  initMegaMenu(node, CLASSES);
  initMobileMenu(node, CLASSES);
  initSearch(node, CLASSES, app);
};

export default Component;
